import { Chip } from "@components/atoms/Chip"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed, THEMES } from "@components/atoms/Themed"
import { Gradient } from "@components/motion/Gradient"
import { Icon } from "@components/ui/Icon"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Program Header",
  description: "Header block for program archive pages",
  inserter: false,
  postMetaBlock: {
    postTypes: ["program"],
    fieldName: "archiveInfo",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("archive/program-header", (props) => {
  const defaultTitle =
    [props.program?.programInfo?.programTypeLabelLong, props.program?.programInfo?.festivalYear]
      .filter(Boolean)
      .join(" ") || props.program?.title

  return (
    <Themed theme="yellow" type="bg" className="w-full py-4 relative mb-8">
      <Gradient
        theme="yellow"
        className="absolute left-0 top-0 h-full bg-white"
        aspect="1/1"
        showImage={false}
        cutEdges={false}
        align="left"
        scale={1}
        // speed={0.5}
        bg={{ r: 1, g: 1, b: 1 }}
      />
      <div className="grid-auto relative z-10">
        <div className="col-span-12 md:col-span-7 flex flex-col justify-between items-start w-full self-stretch relative">
          <div className="flex flex-col gap-6 mt-5 md:w-cols-6">
            <div className="flex gap-2">
              <Chip>{props.program?.programInfo?.festivalYear}</Chip>
              {props.program?.programInfo?.status === "Archived" && <Chip>Archived</Chip>}
            </div>
            <EditableText
              store="title"
              as="h1"
              placeholder="Enter title"
              plainText
              className="type-title-l md:type-title-xxl text-pretty"
              defaultValue={defaultTitle}
            />
          </div>
          <div className="w-full md:w-cols-6">
            {props.links && props.links.length > 0 && (
              <div className="border-t pt-2 mb-6 mt-6 border-black">
                <ul className="flex flex-col">
                  {props.links.map((item, index) => (
                    <li key={index} className="block">
                      <Link
                        href={item?.link?.url!}
                        className="type-label-s-light py-2 flex items-center justify-between w-full"
                      >
                        <span>{item?.link?.title}</span>
                        <span className="border-[1.5px] border-black aspect-square size-[18px] items-center justify-center inline-flex flex-none">
                          <Icon name="arrowRight" className="size-[12px] -rotate-45" />
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <InnerBlocks
              allowedBlocks={["core/paragraph"]}
              defaultBlocks={[["core/paragraph", { placeholder: "Enter an optional intro here" }]]}
            />
          </div>
        </div>
        <div className="col-span-12 md:col-span-5">
          {env.admin && !props.posterImage ? (
            <div className="aspect-[3/4] border bg-black/80 text-white type-label-l flex items-center justify-center text-center">
              Please upload a poster
            </div>
          ) : null}
          <ResponsiveImage {...props.posterImage} className="border border-black" />
        </div>
      </div>
    </Themed>
  )
})
